import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { CustomImageHandler } from '../../../shared/components/CustomImageHandler';
import { InternalRoutes } from '../../../enum/InternalRoutes';
import { Company } from '../../../model/user/Company';
import { IAllStates } from '../../../store/rootReducer';
import { ClientService } from '../../../app/brand/client/service';
import { deselectSupplier } from '../../../store/brand/clientSlice';
import { SupplierHeaderList } from './SupplierHeaderList';
import { FindSuppliersModal } from './FindSuppliersModal';

export function ClientHeader() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { selectedSupplier } = useSelector((state: IAllStates) => state.client);
    const [suppliers, setSuppliers] = useState<Company[]>([]);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        ClientService.getClientsOrSuppliers({ type: 'supplier', page: 1, perPage: 0, onlyWithActive: true }).then(
            response => {
                setSuppliers(response.data);
            }
        );
    }, []);

    const handleDeselect = () => {
        dispatch(deselectSupplier());
    };

    const navigateTo = (path: string) => {
        navigate(path);
    };

    return (
        <>
            <FindSuppliersModal show={showModal} closeModal={() => setShowModal(false)} />
            <div className="agency-header d-flex justify-content-between align-items-center">
                {selectedSupplier?.id ? (
                    <div className="d-flex align-items-center col-auto col-md-2 px-0">
                        <CustomImageHandler
                            classes="user-placeholder"
                            photoPath={selectedSupplier?.profilePhoto?.path ?? ''}
                            thumbnailPath={selectedSupplier?.profilePhoto?.thumbnail ?? ''}
                            altTag="User Profile"
                            name={selectedSupplier?.displayName}
                        />
                        <div className="ml-2">
                            <h6 className="mb-1">{selectedSupplier?.displayName}</h6>
                        </div>
                    </div>
                ) : (
                    <div className="col-2 px-0" />
                )}
                <div className="d-none d-md-flex" style={{ paddingLeft: 64 }}>
                    <div
                        onClick={handleDeselect}
                        className={`agency-filter-rounded-img mr-2 ${selectedSupplier?.id ? 'bg-white' : 'bg-primary'}`}
                    >
                        <strong className={`mb-0 ${selectedSupplier?.id ? 'text-primary' : 'text-white'}`}>MY</strong>
                    </div>
                    <SupplierHeaderList suppliers={suppliers} />
                    <div onClick={() => setShowModal(true)} className="agency-filter-rounded-img">
                        <img src="/icons/img-search.png" alt="search" />
                    </div>
                </div>
                <div className="col-2 px-0 d-flex justify-content-end">
                    {/* <Button
                        onClick={() => navigateTo(InternalRoutes.AGENCY_CAMPAIGNS)}
                        className="d-none d-md-flex"
                        variant="outline-primary"
                        size="sm"
                    >
                        {t('agency.see_all_camp')}
                    </Button> */}
                </div>
                <div className="d-flex d-md-none align-items-center">
                    <div
                        onClick={handleDeselect}
                        className={`d-flex d-md-none mr-4 agency-filter-rounded-img mr-2 ${
                            selectedSupplier?.id ? 'bg-white' : 'bg-primary'
                        }`}
                    >
                        <strong className={`mb-0 ${selectedSupplier?.id ? 'text-primary' : 'text-white'}`}>MY</strong>
                    </div>
                    <img
                        onClick={() => setShowModal(true)}
                        src="/icons/change-agency-influencer.svg"
                        className="d-flex d-md-none"
                        alt="agency-influencer"
                    />
                </div>
            </div>
        </>
    );
}
